module.exports = __webpack_public_path__ + "static/media/star.7fd8c920.svg";